import styled from 'styled-components';

export const PreviewContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.colorPalette.grey.grey4};
  border-radius: 8px;
  overflow: hidden;
  min-width: 260px;
  max-width: 260px;
  flex-shrink: 0;
  cursor: pointer;
`;

export const PreviewImage = styled.img<{ isDark?: boolean }>`
  width: 100%;
  height: 148px;
  object-fit: contain;
  display: block;

  ${({ isDark }) => isDark && 'filter: brightness(0.8);'}
`;

export const DocContent = styled.div`
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const DocTitle = styled.div`
  font-size: ${({ theme }) => theme.fontSizePalette.medium};
  font-weight: 500;
  color: ${({ theme }) => theme.colorPalette.grey.grey9};
`;

export const FileIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 4px;
  background-color: ${({ theme }) => theme.colorPalette.turquoise.accent2};
`;
